import { jsonBody, requestJson } from "../http/httpClient";
import { readObject, readString } from "../http/jsonDecoding";
import { readItemListing } from "./processItemsApi";

/**
 * Folding competency questions in a change set's review (D6 fold): while its review step waits, a
 * curator of every question named keeps one and folds the others into it, in one commit at a new
 * head. The server's route acts through the Thread step that decides the change set.
 */

/** A competency question at one commit, by its words. */
export interface ListedQuestion {
  readonly itemId: string;
  readonly question: string;
}

export interface QuestionFoldRequest {
  readonly reviewedHead: string;
  readonly keep: string;
  readonly fold: readonly string[];
  /** New words for the kept question; `null` keeps its own. */
  readonly question: string | null;
  readonly clientKey: string;
}

/** Every competency question at `commit` of the project content, such as a change set's head. */
export async function questionsAt(projectId: string, commit: string, signal?: AbortSignal): Promise<readonly ListedQuestion[]> {
  const items = await readItemListing(projectId, signal, commit);
  return [...items].filter(([, item]) => item.kind === "competency_question").map(([itemId, item]) => ({ itemId, question: item.name }));
}

/** Fold on exactly the head the curator saw; the change set's new head. */
export function foldQuestions(changeSetId: string, fold: QuestionFoldRequest): Promise<{ readonly head: string }> {
  return requestJson({
    method: "POST",
    path: `/content/change-sets/${encodeURIComponent(changeSetId)}/folds`,
    body: jsonBody({
      reviewed_head: fold.reviewedHead,
      keep: fold.keep,
      fold: fold.fold,
      question: fold.question,
      comment: null,
      client_key: fold.clientKey,
    }),
    decodeResponse: (body) => ({ head: readString(readObject(body, "fold"), "head") }),
  });
}
